import React, { Component } from 'react';
import { connect } from 'react-redux';
import salesTaxTotal from '../../selectors/salesTaxTotal.selector';

class SalesTaxTotal extends Component {
  render() {
    const { total } = this.props;
    return (
      <div className="Row Row-finalTotalRow">
        <input tabIndex="-1" className="Row-total Row-finalTotal" id="SNewTotal" data-tooltip="Registration Total" type="text" value={total || '0.00'} readOnly />
        <label className="Row-finalTotalLabel" htmlFor="SNewTotal">SALES TAX TOTAL</label>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    total: salesTaxTotal(state),
  };
};

export default connect(mapStateToProps)(SalesTaxTotal);



// WEBPACK FOOTER //
// ./src/containers/salestaxes/SalesTaxTotal.js